







import { computed, defineComponent } from "@vue/composition-api";
import {
  CustomRequestMessageDetails,
  isCustomRequestMessageDetails,
  Message,
} from "@scrile/api-provider/dist/api/MessagesProvider";

export default defineComponent({
  name: "MessagePreviewCustomRequest",
  props: {
    message: { type: Object as () => Message, required: true },
    authUserId: { type: String, required: true },
  },
  setup(props) {
    const details = computed<CustomRequestMessageDetails | null>(() =>
      isCustomRequestMessageDetails(props.message.details) ? props.message.details : null
    );
    const opponentMessage = computed(() => Number(details.value?.senderId) !== Number(props.authUserId));
    return { opponentMessage };
  },
});
